import React from "react";

import { ErrorBoundary } from "@at/design-system-patterns";

import { LeasingBusinessType } from "./children/business-type/leasing-business-type";
import { CheckYourEligibility } from "./children/check-your-eligibility/check-your-eligibility";
import { CommissionDisclosure } from "./children/commission-disclosure/commission-disclosure";
import { CustomiseYourPayment } from "./children/customise-your-payment/customise-your-payment";
import { CustomiseYourVehicle } from "./children/customise-your-vehicle/customise-your-vehicle";
import { HowLeasingWorksTabs } from "./children/how-leasing-works-tabs/how-leasing-works-tabs";
import { LeaseContractSwitcher } from "./children/lease-contract-switcher/lease-contract-switcher";
import { LeasingPricing } from "./children/pricing/leasing-pricing";
import { LeaseContractType } from "../../../__generated__/graphql-types";
import { useLeasingStateContext } from "../../../contexts/leasing/context/leasing.context";

interface LeasingContractCustomiserProps {
  leaseOffersLoading: boolean;
}

export const LeasingContractCustomiser = ({
  leaseOffersLoading,
}: LeasingContractCustomiserProps) => {
  const state = useLeasingStateContext();
  const { leaseContractType, selectedBusinessType } = state;
  const isBusinessLease = leaseContractType === LeaseContractType.business;

  return (
    <ErrorBoundary>
      <LeaseContractSwitcher />
      {isBusinessLease && <LeasingBusinessType />}
      <CustomiseYourVehicle />
      <CustomiseYourPayment />
      <HowLeasingWorksTabs />
      <CommissionDisclosure />
      {!["limitedLiabilityPartnership", "limitedCompany"].includes(
        selectedBusinessType,
      ) && <CheckYourEligibility />}
      <LeasingPricing leaseOffersLoading={leaseOffersLoading} />
    </ErrorBoundary>
  );
};
